import classnames from "classnames";
import React from "react";
import styled, { css } from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import { iDef } from "core/util/TypeUtils";
import StringUtil from "../../../core/util/StringUtil";
import { toBlockCss } from "../common/BlockStylesConfig";
import { toTypographyCss } from "../common/TypographyStylesConfig";
import CardViewConfig from "./CardConfig";

interface ICardProps {
	interactive?: boolean;
	useOwnPdding?: boolean;
	config: CardViewConfig;
}

export const CardField = styled.div``;
export const CardInlineField = styled.span``;

const Card = styled.div<ICardProps>`
	color: inherit;
	text-decoration: none;
	display: block;
	overflow: hidden;
	position: relative;

	${({config, interactive}: ICardProps) => css`

		min-height: ${config.minHeight};
		transition: ${config.transition};

		& ${CardField} + ${CardField} {
			margin-top: ${config.spacing};
		}

		& ${CardInlineField} + ${CardInlineField} {
			margin-left: ${config.spacing};
		}

		${toTypographyCss(config.typography)}
		${toBlockCss(config.defaultState)}
		${interactive && css`
			cursor: pointer;
			&:hover {
				${toBlockCss(config.hoverState)}
			}
			&:active {
				${toBlockCss(config.activeState)}
			}
		`}
	`}
`;

export enum CardVariant {
	MINIMAL = "minimal", // no/minimal shadow/border
	SURFACE = "surface", // white background
	ALT = "alternate" , // alt grey-ish color background, for cards inside of cards?
	DEFAULT= "default" // default used for cardview with border
}

interface ICardViewProps extends IViewProps<CardViewConfig, CardVariant> {
	interactive?: boolean;
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

/**
 * @description basic div view with optional interactive states
 */
@View({id: "card", configClass: CardViewConfig, variants: CardVariant})
export class CardView extends React.PureComponent<ICardViewProps> {

	public render() {
		return (
			<Card
				config={this.props.config}
				onClick={this.props.onClick}
				interactive={this.props.interactive || iDef(this.props.onClick)}
				className={classnames({"auto-height": this.props.config.autoResize})}
				data-uuid={StringUtil.format("%s.%s", this.props.panelInstance, this.props.viewKey)}
				style={this.props.style}
			>
				{this.props.children}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/card/Card.view.tsx